import { render, staticRenderFns } from "./GebenLanding.vue?vue&type=template&id=fefc286e&scoped=true&"
import script from "./GebenLanding.vue?vue&type=script&lang=js&"
export * from "./GebenLanding.vue?vue&type=script&lang=js&"
import style0 from "./GebenLanding.vue?vue&type=style&index=0&id=fefc286e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefc286e",
  null
  
)

export default component.exports